import Vue from 'vue'
import Router from 'vue-router'
import Footer from '@/components/footer.vue'
import Index from '@/views/index/index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/footer',
      name: 'Footer',
      component: Footer
    },
    {
      path: '/',
      name: 'Index',
      component: Index
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js